<div class="uk-text-center">

    <h2 class="page-heading">Voicemail</h2>

    <mat-tab-group>

        <mat-tab label="Agent Voicemail">
            <br>
            <app-agent-voicemail></app-agent-voicemail>
        </mat-tab>

        <mat-tab label="Voicemail Extension">
            <br>
            <app-voicemail-extension></app-voicemail-extension>
        </mat-tab>

        <mat-tab label="Group Voicemail">
            <br>
            <app-group-voicemail></app-group-voicemail>
        </mat-tab>

        <mat-tab label="Voicemail Extension Batch">
            <ng-template matTabContent>
                <app-voicemail-extension-upload></app-voicemail-extension-upload>
            </ng-template>            
        </mat-tab>

    </mat-tab-group>

</div>
